import { BodyBold, BodyRegular } from "@styles/typography";
import { Button, DataColumn, DetailContainer, Form, TransferDataRow } from "./AcceptForm.styled";

const TransferDetail = ({ header, data }: { header: string; data: string }) => (
  <TransferDataRow>
    <DataColumn>
      <BodyBold>{header}</BodyBold>
    </DataColumn>
    <DataColumn>
      <BodyRegular>{data}</BodyRegular>
    </DataColumn>
  </TransferDataRow>
);
interface AcceptFormProps {
  transferFrom: string;
  transferCreated: string;
  onSubmit: () => void;
}

const AcceptForm = ({ transferFrom, transferCreated, onSubmit }: AcceptFormProps) => {
  return (
    <div data-testid="transfer-accept-form">
      <h3>Pending Account Transfer</h3>
      <BodyRegular>
        {
          "Before being able to access your Mirror, you will need to add a valid credit card to your account, which will be used to process monthly Membership payments ($39/mo.)"
        }
      </BodyRegular>
      <DetailContainer>
        <TransferDetail header="Transfer From" data={transferFrom} />
        <TransferDetail header="Date Created" data={transferCreated} />
        <TransferDetail header="Status" data="Pending" />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}>
          <Button type="submit">{"Accept Transfer"}</Button>
        </Form>
      </DetailContainer>
    </div>
  );
};

export default AcceptForm;
